import {memo} from 'react';

import {AppButton, AppButtonVariant} from '@/app/shared-components/AppButton';

interface SplitResultGroupActionsProps {
  onImDonePress: () => void;
  onNewSplitPress: () => void;
  imDoneLabel: string;
  newSplitLabel: string;
}

export const SplitResultGroupActions = memo(
  ({
    onImDonePress,
    onNewSplitPress,
    imDoneLabel,
    newSplitLabel,
  }: SplitResultGroupActionsProps) => {
    return (
      <div className="split-result-actions split-result-group-actions">
        <div className="split-result-group-actions-im-done">
          <AppButton
            id="split-result-im-done"
            label={imDoneLabel}
            variant={AppButtonVariant.onQuinary}
            onClick={onImDonePress}
          />
        </div>
        <div className="split-result-group-actions-new-split">
          <AppButton
            id="split-result-new-split"
            label={newSplitLabel}
            variant={AppButtonVariant.onPrimary}
            onClick={onNewSplitPress}
          />
        </div>
      </div>
    );
  },
);
